import React from 'react';

import styled from 'styled-components';

import { skeletonGradient } from '~/searchCio/utils/styles';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 16px 0px;
`;

const Placeholder = styled.div`
  ${skeletonGradient}
`;

const FirstPlaceholder = styled(Placeholder)`
  height: 24px;
  width: 142px;
`;

const LargePlaceholder = styled(Placeholder)`
  height: 24px;
  width: 236px;
  margin-top: 8px;
`;

const BottomWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top 32px;
`;

const SmallPlaceholder = styled(Placeholder)`
  height: 18px;
  width: 133px;
  margin-bottom: 0;
`;

const TextListSkeletonLoaderMobile = () => {
  return (
    <Wrapper>
      <FirstPlaceholder />
      <LargePlaceholder />
      <LargePlaceholder />
      <LargePlaceholder />

      <BottomWrapper>
        <SmallPlaceholder />
        <SmallPlaceholder />
      </BottomWrapper>
    </Wrapper>
  );
};

export default TextListSkeletonLoaderMobile;
